module.exports = __webpack_public_path__ + "static/media/help.62354190.png";